module.exports = __webpack_public_path__ + "img/horizontal-logo.fd8ec351.svg";